function SavingIcon() {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.3518 83.2351H26.9106C25.8812 86.9116 25.7341 91.4704 26.6165 95.2939C26.7635 95.8822 27.2047 96.3233 27.7929 96.4704C30.5871 97.2057 33.5282 97.2057 36.3224 96.4704C36.9106 96.3233 37.3518 95.8822 37.4988 95.2939C38.2341 91.4704 38.2341 86.9116 37.3518 83.2351Z"
        fill="#FABDAB"
      />
      <path
        d="M37.3531 83.2351H35.5884C36.0295 86.3233 35.8825 89.7057 35.2942 92.6469C35.1472 93.2351 34.706 93.6763 34.1178 93.8233C31.4707 94.5586 28.9707 94.5586 26.4707 93.9704C26.4707 94.4116 26.6178 94.7057 26.7648 95.1469C26.9119 95.7351 27.3531 96.1763 27.9413 96.3233C30.7354 97.0586 33.6766 97.0586 36.4707 96.3233C37.0589 96.1763 37.5001 95.7351 37.6472 95.1469C38.2354 91.4704 38.2354 86.9116 37.3531 83.2351Z"
        fill="#F2A496"
      />
      <path
        d="M73.6779 83.2356H63.2368C62.2074 86.9121 62.0603 91.4709 62.9427 95.2944C63.0897 95.8827 63.5309 96.3238 64.1191 96.4709C66.9132 97.2062 69.8544 97.2062 72.6485 96.4709C73.2368 96.3238 73.6779 95.8827 73.825 95.2944C74.7074 91.4709 74.5603 86.9121 73.6779 83.2356Z"
        fill="#FABDAB"
      />
      <path
        d="M73.6734 83.2358H71.9087C72.3498 86.3241 72.2028 89.7064 71.6145 92.6476C71.4675 93.2358 71.0263 93.677 70.4381 93.8241C67.791 94.5594 65.291 94.5594 62.791 93.9711C62.791 94.4123 62.9381 94.7064 63.0851 95.1476C63.2322 95.7358 63.6734 96.177 64.2616 96.3241C67.0557 97.0594 69.9969 97.0594 72.791 96.3241C73.3793 96.177 73.8204 95.7358 73.9675 95.1476C74.7028 91.4711 74.5557 86.9123 73.6734 83.2358Z"
        fill="#F2A496"
      />
      <path
        d="M83.2345 64.7063C83.2345 82.9416 68.3815 94.4122 50.1463 94.4122C31.911 94.4122 17.2051 82.9416 17.2051 64.7063C17.2051 46.471 32.058 33.824 50.2933 33.824C68.5286 33.824 83.2345 46.324 83.2345 64.7063Z"
        fill="#FABDAB"
      />
      <path
        d="M78.2341 47.6477C78.3812 49.1183 78.5283 50.5889 78.5283 52.0595C78.5283 71.7654 62.4989 84.2654 42.793 84.2654C34.2636 84.2654 26.4694 81.9124 20.293 77.7948C25.44 88.2359 37.0577 94.4124 50.44 94.4124C68.6753 94.4124 83.5283 82.9418 83.5283 64.7065C83.2341 58.0889 81.4694 52.3536 78.2341 47.6477Z"
        fill="#F2A496"
      />
      <path
        d="M61.4701 70.1475C61.4701 75.5887 56.4701 78.971 50.2937 78.971C44.1172 78.971 39.1172 75.5887 39.1172 70.1475C39.1172 64.7063 44.1172 60.8828 50.2937 60.8828C56.4701 60.8828 61.4701 64.7063 61.4701 70.1475Z"
        fill="#EA8B82"
      />
      <path
        d="M60.8815 72.2064C60.8815 76.7652 56.1757 79.5593 50.2933 79.5593C44.411 79.5593 39.7051 76.7652 39.7051 72.2064C39.7051 67.6476 44.411 64.5593 50.2933 64.5593C56.1757 64.5593 60.8815 67.6476 60.8815 72.2064Z"
        fill="#F2A496"
      />
      <path
        d="M54.2663 69.5593C53.6781 69.5593 53.0898 70.0005 53.0898 70.7358V75.0005C53.0898 75.5887 53.531 76.177 54.2663 76.177C55.0016 76.177 55.4428 75.7358 55.4428 75.0005V70.5887C55.4428 70.0005 54.8546 69.5593 54.2663 69.5593Z"
        fill="#1D2943"
      />
      <path
        d="M46.1784 69.5593C45.5902 69.5593 45.002 70.0005 45.002 70.7358V75.0005C45.002 75.5887 45.4431 76.177 46.1784 76.177C46.7667 76.177 47.3549 75.7358 47.3549 75.0005V70.5887C47.3549 70.0005 46.9137 69.5593 46.1784 69.5593Z"
        fill="#1D2943"
      />
      <path
        d="M62.3376 49.5233C62.5966 48.7536 62.0577 47.8776 61.134 47.5667C60.2103 47.2559 59.2515 47.6279 58.9924 48.3977C58.7334 49.1675 59.2723 50.0435 60.196 50.3543C61.1197 50.6651 62.0785 50.2931 62.3376 49.5233Z"
        fill="#1D2943"
      />
      <path
        d="M40.1594 50.413C41.0831 50.1022 41.622 49.2262 41.3629 48.4564C41.1039 47.6866 40.1451 47.3146 39.2214 47.6254C38.2977 47.9363 37.7588 48.8123 38.0178 49.582C38.2769 50.3518 39.2357 50.7238 40.1594 50.413Z"
        fill="#1D2943"
      />
      <path
        d="M72.0573 25.0011C84.1161 23.5305 82.0573 37.6482 81.7632 40.2952C81.322 42.9423 80.2926 47.207 76.6161 51.3247C73.9691 42.3541 67.7926 37.9423 58.3809 37.7952C58.3809 37.9423 59.9985 26.4717 72.0573 25.0011Z"
        fill="#FABDAB"
      />
      <path
        d="M79.2632 31.0304C77.6456 28.6775 75.1456 27.2069 72.3515 27.2069C68.9691 27.0598 63.8221 28.5304 59.2632 36.3245C58.8221 37.0598 59.1162 38.0892 59.9985 38.5304C66.0279 40.7363 71.175 44.5598 75.2927 49.7069C75.8809 50.5892 77.2044 50.4422 77.7927 49.4128C79.7044 45.5892 83.2338 37.0598 79.2632 31.0304Z"
        fill="#EA8B82"
      />
      <path
        d="M77.7936 49.4128C79.7054 45.5893 83.2348 36.9128 79.2642 31.0305C78.823 30.4423 78.3819 29.854 77.7936 29.4128C75.8819 29.4128 73.823 29.854 71.323 31.1775C67.7936 33.0893 67.0583 37.9423 69.9995 40.7364C72.7936 43.3834 75.1466 46.6187 76.9113 50.2952C77.2054 50.1481 77.4995 49.854 77.7936 49.4128Z"
        fill="#F2A496"
      />
      <path
        d="M28.383 25.0011C16.3242 23.5305 18.383 37.6482 18.6771 40.2952C19.1183 42.9423 20.1477 47.207 23.8242 51.3247C26.4713 42.3541 32.6477 37.9423 42.0595 37.7952C42.0595 37.9423 40.4418 26.4717 28.383 25.0011Z"
        fill="#FABDAB"
      />
      <path
        d="M21.3245 31.0304C22.9421 28.6775 25.4421 27.2069 28.2362 27.2069C31.6186 27.0598 36.7656 28.5304 41.3245 36.3245C41.7656 37.0598 41.4715 38.0892 40.5892 38.5304C34.5598 40.7363 29.4127 44.5598 25.2951 49.7069C24.7068 50.5892 23.3833 50.4422 22.795 49.4128C20.7362 45.5892 17.2068 37.0598 21.3245 31.0304Z"
        fill="#F2A496"
      />
      <path
        d="M33.2362 28.2359C31.3245 27.3536 29.5598 27.0595 28.2362 27.2065C25.4421 27.3536 22.9421 28.8242 21.3245 31.0301C17.2068 37.0595 20.7362 45.5889 22.795 49.4124C23.2362 50.2948 24.5598 50.4418 25.2951 49.7065C25.5892 49.4124 25.8833 48.9712 26.1774 48.6771C22.795 38.2359 29.8539 30.883 33.2362 28.2359Z"
        fill="#EA8B82"
      />
      <path
        d="M63.7889 14.2877C63.7889 20.7192 58.5739 25.9296 52.1425 25.9296C45.711 25.9296 40.4961 20.7192 40.4961 14.2877C40.4961 7.85629 45.711 2.64136 52.1425 2.64136C58.5739 2.64136 63.7889 7.85629 63.7889 14.2877Z"
        fill="#F7F363"
      />
      <path
        d="M60.748 14.2888C60.748 15.7039 60.4059 17.0374 59.7956 18.2154C58.3687 20.9873 55.4763 22.8884 52.1446 22.8884C48.8167 22.8884 45.9203 20.9873 44.4935 18.2154C43.8832 17.0374 43.541 15.7039 43.541 14.2888C43.541 9.54191 47.4015 5.6814 52.1446 5.6814C56.8914 5.6814 60.748 9.54191 60.748 14.2888Z"
        fill="#F9B938"
      />
      <path
        d="M53.1275 10.0771L54.0813 12.0098L56.2142 12.3197C57.114 12.4505 57.4733 13.5563 56.8222 14.1909L55.2789 15.6953L55.6432 17.8195C55.7969 18.7157 54.8562 19.3992 54.0514 18.976L52.1437 17.9731L50.2361 18.976C49.4313 19.3992 48.4906 18.7157 48.6443 17.8195L49.0086 15.6953L47.4653 14.1909C46.8142 13.5563 47.1735 12.4505 48.0733 12.3197L50.2061 12.0098L51.16 10.0771C51.5624 9.26173 52.7251 9.26173 53.1275 10.0771Z"
        fill="#FFF4DE"
      />
      <path
        d="M56.8172 14.1932L55.2726 15.6925C55.3102 15.9101 55.1364 14.9045 55.6404 17.82C55.7924 18.7149 54.853 19.3962 54.0495 18.9737C53.0096 18.4268 52.0856 17.945 52.1381 17.9727L50.2314 18.9742C49.4279 19.3986 48.4887 18.714 48.6415 17.82L48.6924 17.5087C48.9074 18.0915 49.609 18.4197 50.2314 18.0972L51.8375 17.2489C52.0218 17.1515 52.2452 17.1665 52.4149 17.2876L53.3372 17.9457C53.8364 18.302 54.5759 17.991 54.5991 17.3782C54.6005 17.3411 54.5988 17.307 54.5937 17.2768L54.2802 15.4398C54.2497 15.2615 54.3087 15.0796 54.4381 14.9531L55.7705 13.65C56.1723 13.2596 56.1892 12.6882 55.9346 12.2808L56.2119 12.3204C57.1115 12.4505 57.4679 13.5538 56.8172 14.1932Z"
        fill="#FFF4DE"
      />
      <g clipPath="url(#clip0_7612_51047)">
        <path
          d="M89.1272 70.7157C89.1272 75.3606 85.3609 79.1237 80.716 79.1237C76.071 79.1237 72.3047 75.3606 72.3047 70.7157C72.3047 66.0708 76.071 62.3044 80.716 62.3044C85.3609 62.3044 89.1272 66.0708 89.1272 70.7157Z"
          fill="#F7F363"
        />
        <path
          d="M86.9273 70.7167C86.9273 71.7387 86.6802 72.7018 86.2394 73.5526C85.2089 75.5545 83.1199 76.9275 80.7137 76.9275C78.3102 76.9275 76.2184 75.5545 75.1879 73.5526C74.7471 72.7018 74.5 71.7387 74.5 70.7167C74.5 67.2884 77.2882 64.5002 80.7137 64.5002C84.142 64.5002 86.9273 67.2884 86.9273 70.7167Z"
          fill="#F9B938"
        />
        <path
          d="M81.4233 67.6751L82.1121 69.0709L83.6525 69.2947C84.3024 69.3891 84.5619 70.1878 84.0916 70.6462L82.977 71.7327L83.2401 73.2668C83.3511 73.9141 82.6718 74.4076 82.0905 74.1021L80.7128 73.3777L79.335 74.1021C78.7537 74.4076 78.0744 73.9141 78.1854 73.2668L78.4485 71.7327L77.3339 70.6462C76.8636 70.1878 77.1231 69.3891 77.773 69.2947L79.3134 69.0709L80.0023 67.6751C80.2929 67.0862 81.1326 67.0862 81.4233 67.6751Z"
          fill="#FFF4DE"
        />
        <path
          d="M84.0904 70.6478L82.9749 71.7307C83.002 71.8878 82.8765 71.1616 83.2405 73.2671C83.3503 73.9135 82.6718 74.4055 82.0915 74.1004C81.3404 73.7054 80.6732 73.3575 80.7111 73.3775L79.334 74.1008C78.7537 74.4072 78.0754 73.9128 78.1857 73.2671L78.2225 73.0424C78.3778 73.4633 78.8845 73.7003 79.334 73.4674L80.4939 72.8547C80.627 72.7844 80.7884 72.7952 80.911 72.8826L81.5771 73.358C81.9376 73.6153 82.4717 73.3907 82.4884 72.9481C82.4894 72.9213 82.4883 72.8967 82.4845 72.8749L82.2581 71.5481C82.2361 71.4193 82.2788 71.288 82.3721 71.1966L83.3345 70.2555C83.6246 69.9735 83.6369 69.5609 83.453 69.2666L83.6532 69.2952C84.3029 69.3892 84.5604 70.186 84.0904 70.6478Z"
          fill="#FFF4DE"
        />
      </g>
      <path
        d="M29.8401 76.4298C29.8401 81.0748 26.0738 84.8378 21.4289 84.8378C16.7839 84.8378 13.0176 81.0748 13.0176 76.4298C13.0176 71.7849 16.7839 68.0186 21.4289 68.0186C26.0738 68.0186 29.8401 71.7849 29.8401 76.4298Z"
        fill="#F7F363"
      />
      <path
        d="M27.6421 76.4308C27.6421 77.4528 27.3951 78.4159 26.9542 79.2667C25.9238 81.2686 23.8347 82.6416 21.4285 82.6416C19.025 82.6416 16.9332 81.2686 15.9027 79.2667C15.462 78.4159 15.2148 77.4528 15.2148 76.4308C15.2148 73.0025 18.003 70.2144 21.4285 70.2144C24.8568 70.2144 27.6421 73.0025 27.6421 76.4308Z"
        fill="#F9B938"
      />
      <path
        d="M22.1381 73.3887L22.827 74.7845L24.3674 75.0083C25.0172 75.1028 25.2767 75.9014 24.8065 76.3598L23.6918 77.4463L23.955 78.9804C24.066 79.6277 23.3866 80.1213 22.8054 79.8157L21.4276 79.0914L20.0498 79.8157C19.4686 80.1213 18.7892 79.6277 18.9002 78.9804L19.1634 77.4463L18.0487 76.3598C17.5785 75.9014 17.838 75.1028 18.4878 75.0083L20.0282 74.7845L20.7171 73.3887C21.0077 72.7998 21.8475 72.7998 22.1381 73.3887Z"
        fill="#FFF4DE"
      />
      <path
        d="M24.8053 76.3615L23.6897 77.4443C23.7169 77.6014 23.5913 76.8752 23.9554 78.9808C24.0651 79.6271 23.3867 80.1192 22.8064 79.814C22.0553 79.419 21.388 79.0711 21.4259 79.0911L20.0488 79.8144C19.4686 80.1209 18.7902 79.6264 18.9006 78.9808L18.9373 78.756C19.0926 79.1769 19.5993 79.4139 20.0488 79.181L21.2088 78.5683C21.3419 78.498 21.5033 78.5088 21.6258 78.5962L22.2919 79.0716C22.6525 79.3289 23.1866 79.1043 23.2033 78.6617C23.2043 78.6349 23.2031 78.6103 23.1994 78.5885L22.973 77.2617C22.951 77.133 22.9936 77.0016 23.087 76.9103L24.0493 75.9691C24.3395 75.6872 24.3517 75.2745 24.1678 74.9802L24.3681 75.0089C25.0178 75.1028 25.2752 75.8996 24.8053 76.3615Z"
        fill="#FFF4DE"
      />
      <defs>
        <clipPath id="clip0_7612_51047">
          <rect
            width="18.5714"
            height="18.5714"
            fill="white"
            transform="translate(71.4258 61.4285)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SavingIcon;
